
document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector('footer')
  const mobFacets = document.querySelector(".mobile-facets__open")
  const mobFacetsClose = document.querySelector(".mobile-facets__close")
  
  mobFacets?.addEventListener('click', function () {
    if(footer){
      footer.style.display = 'none'
    }
  })
  
  mobFacetsClose?.addEventListener('click', function () {
    if(footer){
      footer.style.display = 'block'
    }
  })
})

// announcement bar
class AnnouncementMarquee extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    this.swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 0,
      loop: true,
      freeMode: true,
      allowTouchMove: false,
      speed: 20000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if(!customElements.get("fs-announcement-marquee")){
  customElements.define("fs-announcement-marquee", AnnouncementMarquee);
}




class FsInstaSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const swiper = new Swiper('.fs_insta_slider', {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesPerGroup: 1,
      speed: 1000,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
          speed: 1200,
          freeMode: false,
        },
      },
    });
  }
}
if (!customElements.get('fs-insta-slider')) {
  customElements.define('fs-insta-slider', FsInstaSlider);
}

class FsAiImageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.sliderInitialized) return;
    this.sliderInitialized = true;
    const swiperEl = this.querySelector('.swiper');
    const prev = this.querySelector('.swiper-button-prev');
    const next = this.querySelector('.swiper-button-next');

    new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 20,
      loop: true,
      // freeMode: true,
      // watchOverflow: true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
          loop: false,
        },
      },
    });
  }
}
if (!customElements.get('fs-ai-image-slider')) {
  customElements.define('fs-ai-image-slider', FsAiImageSlider); 
}


class AnimatedAccordion extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.accordion__trigger');
    this.content = this.querySelector('.accordion__content');

    if (!this.trigger || !this.content) return;

    this.content.style.maxHeight = '0px';
    this.content.style.overflow = 'hidden';

    this.trigger.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const beforeTop = this.trigger.getBoundingClientRect().top;
    const isOpen = this.classList.contains('is-open');

    if (isOpen) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;

      requestAnimationFrame(() => {
        this.content.style.maxHeight = '0px';
      });

      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
    } else {
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    }

    if (window.matchMedia('(min-width: 769px)').matches) {
      setTimeout(() => {
        const rect = this.trigger.getBoundingClientRect();

        const isInViewport =
          rect.top >= 300 &&
          rect.bottom <= window.innerHeight;

        if (isInViewport) return;

        window.scrollBy({
          top: rect.top - 300,
          left: 0,
          behavior: 'smooth'
        });
      }, 300);
    }
  }
}

customElements.define('animated-accordion', AnimatedAccordion);



// pf custom popup
class PfEntryPopup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.closeBtn = this.querySelector(".close_btn");
    this.closeBtn.addEventListener("click", this.closePopup.bind(this));
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.closePopup();
      }
    });

    this.showPopup();
  }
  closePopup() {
    this.classList.remove("active");
  }
  showPopup() {
    const showOneTime = this.getAttribute("one-time");
    const isShow = window.localStorage.getItem("pfEntryPopup");
    window.addEventListener("load", () => {
      if (showOneTime === "true") {
        if (isShow !== "true") {
          this.classList.add("active");
          window.localStorage.setItem("pfEntryPopup", "true");
        }
      } else {
        this.classList.add("active");
      }
    });
  }
}
customElements.define("pf-entry-popup", PfEntryPopup);


// PF Wholesale Management
class WholesaleManagement extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    if (!this.isWholesaler && this.hasWholesaleItems()) {
      this.clearWholesaleItems();
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get isWholesaler() {
    return this.dataset.customerType == "wholesaler";
  }

  get cartProducts() {
    return JSON.parse(this.dataset.cartProducts || "[]");
  }

  get wholesaleCollections() {
    return this.dataset.wholesaleCollections?.split(",") || [];
  }

  get cart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  hasWholesaleItems() {
    return this.cartProducts.some(product => {
      const productCollections = product.collections?.split(",") || [];

      return productCollections.some(col =>
        this.wholesaleCollections.includes(col.trim())
      );
    });
  }

  // async clearWholesaleItems() {
  //   const sections = this.cart.getSectionsToRender().map(s => s.id);

  //   try {
  //     const response = await fetch(`/cart/clear.js?sections=${sections.join(",")}`, {
  //       method: "POST",
  //       headers: {
  //         "X-Requested-With": "XMLHttpRequest",
  //       }
  //     });

  //     const json = await response.json();

  //     this.cart.renderContents(json, false);
  //   } catch (err) {
  //     console.error("Failed to clear wholesale items:", err);
  //   }
  // }

  async clearWholesaleItems() {
    try {
      await fetch("/cart/clear.js");
      window.location.reload();
    } catch (err) {
      console.error("Failed to clear wholesale items:", err);
    }
  }


  redirect(ifNotType, from, to) {
    if (this.dataset.customerType != ifNotType) {
      const path = window.location.pathname;

      if (path.includes(from)) {
        location.replace(to);
      }
    }
  }
}


if(!customElements.get("pf-wholesale-management")) {
  customElements.define("pf-wholesale-management", WholesaleManagement);
}

// Wholesaler login button
document.addEventListener("DOMContentLoaded", () => {
  const loginBtn = document.querySelector(".pf-wholesale-login button");
  const logoutBtn = document.querySelector(".pf-wholesale-logout button");

  loginBtn?.addEventListener("click", e => {
    e.preventDefault();

    window.location = "/account/login";
  });

  logoutBtn?.addEventListener("click", async e => {
    e.preventDefault();

    await fetch("/cart/clear.js");

    window.location = "/account/logout";
  });


  // quantity
  // const quantityInput = document.querySelector(".product-form__quantity quantity-input .quantity__input");
  // const price = document.querySelector(".product__info-wrapper .price__container .price-item .money");

  // if (quantityInput && price) {
  //   const basePrice = price.innerText;

  //   function updatePrice() {
  //     // Extract numeric value from the price
  //     const originalPrice = parseFloat(basePrice.replace(/[^0-9.-]+/g, ""));

  //     // Extract the currency symbol or any non-digit prefix/suffix
  //     const currencyPrefix = basePrice.match(/^[^\d]+/)?.[0] || "";
  //     const currencySuffix = basePrice.match(/[^\d]+$/)?.[0] || "";

  //     const productType = quantityInput.getAttribute("product-type");
  //     let quantity = parseFloat(quantityInput.value) || 1;

  //     if(productType.includes("its_fabric")){
  //       quantity = parseFloat(quantityInput.nextElementSibling.value) || 1;
  //     }
      
  //     let newPrice = originalPrice * quantity;

  //     // Keep original currency formatting
  //     price.innerText = `${currencyPrefix}${newPrice}${currencySuffix}`;
  //   }

  //   updatePrice();

  //   quantityInput.addEventListener("change", () => {
  //     updatePrice();
  //   });
  // }

});


// cart
(function (ns, originalFetch) {
  if (typeof originalFetch !== 'function') return;

  ns.fetch = function (...args) {
    const responsePromise = originalFetch.apply(this, args);

    responsePromise.then(async (res) => {
      if (!res.url.includes('cart/change')) return;

      const data = await res.clone().json().catch(() => null);
      if (!data?.items?.length) return;

      const changedItem =
        data?.items_added?.[0] || data?.items_removed?.[0];

      if (!changedItem) return;

      syncAddonQuantities(data, changedItem.sku);
    });

    return responsePromise;
  };

  async function syncAddonQuantities(cart, sku) {
    const mainProduct = cart.items.find(item => item.sku === sku);
    if (!mainProduct) return;

    const addons = cart.items.filter(
      item => item.properties?.SKU === sku
    );

    if (!addons.length) return;

    const updates = addons.reduce((acc, item) => {
      acc[item.key] = mainProduct.quantity;
      return acc;
    }, {});

    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
})(window, window.fetch);


// megamenu tabs
class FSTabs extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const triggers = this.querySelectorAll('.trigger');
        const tabs = this.querySelectorAll('.tab');

        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                triggers.forEach(trigger => trigger.classList.remove('active'));
                trigger.classList.add('active');

                tabs.forEach(tab => tab.classList.remove('active'));
                const tab = this.querySelector(`.tab[data-tab="${trigger.dataset.tab}"]`);
                tab.classList.add('active');
            });
        });
    }
}

if (!customElements.get('fs-tabs')) {
    customElements.define('fs-tabs', FSTabs);
}


class FSSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const el = this.querySelector(".swiper");
    if (!el) return;

    this.swiper = new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      slidesPerGroup: 1,
      loop: true,
      speed: 1000,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3, 
          speed: 1200,
          freeMode: false,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) this.swiper.destroy(true, true);
  }
}
if (!customElements.get('fs-slider-component')) {
  customElements.define('fs-slider-component', FSSliderComponent);
}


// accordion 
document.addEventListener('DOMContentLoaded', () => {
  const footerMenus = document.querySelectorAll('.footer-block--menu');

  footerMenus.forEach((menu) => {
    const heading = menu.querySelector('.footer-block__heading');

    if (!heading) return;

    heading.addEventListener('click', () => {
      if (window.innerWidth > 749) return;

      menu.classList.toggle('is-open');
    });
  });
});



const sections$1 = {};

const selectors$1 = {
  slider: '[data-slider]',
  item: '[data-item]',
};

const classes$1 = {
  flickityEnabled: 'flickity-enabled',
};

const attributes = {
  sectionId: 'data-section-id',
};

class Slider {
  constructor(section) {
    this.container = section.container;
    this.header = document.querySelector('[data-site-header]');
    this.flkty = null;
    this.resizeEvent = () => {
      this.flkty.resize();
    };

    this.initSlider();
    this.bindScrollButton();
  }

  initSlider() {
    const slidesCount = this.container.querySelectorAll('[data-item]').length;
    const duration = parseInt(this.container.dataset.duration);
    const pageDots = this.container.dataset.pageDots === 'true' && slidesCount > 1;
    const prevNextButtons = this.container.dataset.navArrows === 'true' && slidesCount > 1;
    let autoplay = this.container.dataset.autoplay === 'true';

    if (autoplay) {
      autoplay = duration;
    }

    if (slidesCount > 1) {
      this.flkty = new Flickity(this.container, {
        fade: true,
        cellSelector: '[data-item]',
        autoPlay: autoplay,
        wrapAround: true,
        adaptiveHeight: true,
        setGallerySize: true,
        imagesLoaded: true,
        pageDots: pageDots,
        prevNextButtons: prevNextButtons,
        on: {
          ready: () => {
            const currentStyle = this.container
              .querySelector('[data-item][data-slide-position="1"]')
              .getAttribute('data-style');
            this.container.setAttribute('data-current-style', currentStyle);
            requestAnimationFrame(this.resizeEvent);
            document.addEventListener('theme:vars', this.resizeEvent);
          },
          change: (index) => {
            const currentSlide = this.flkty.selectedElement;
            const currentStyle = currentSlide.getAttribute('data-style');
            this.container.setAttribute('data-current-style', currentStyle);

            this.flkty.cells.forEach((slide, i) => {
              slide.element.querySelectorAll('a, button').forEach((link) => {
                link.setAttribute('tabindex', i === index ? '0' : '-1');
              });
            });
          },
        },
      });

      flickitySmoothScrolling(this.container);
    } else if (slidesCount === 1) {
      const currentStyle = this.container
        .querySelector('[data-item]')
        .getAttribute('data-style');
      this.container.setAttribute('data-current-style', currentStyle);
    }
  }

  bindScrollButton() {
    const arrowDown = this.container.querySelector('[data-scroll-down]');

    if (arrowDown) {
      arrowDown.addEventListener('click', (e) => {
        e.preventDefault();
        const headerFixed = this.header.classList.contains('site-header--fixed');
        const headerHeight = headerFixed ? 60 : 0;
        const scrollToPosition = parseInt(
          Math.ceil(this.container.offsetTop + this.container.offsetHeight - headerHeight)
        );
        window.scrollTo({ top: scrollToPosition, left: 0, behavior: 'smooth' });
      });
    }
  }

  onBlockSelect(evt) {
    const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
    if (this.flkty !== null) {
      this.flkty.select(index);
      this.flkty.pausePlayer();
    }
  }

  onBlockDeselect(evt) {
    const autoplay = evt.target.closest('[data-slider]').dataset.autoplay === 'true';
    if (autoplay && this.flkty !== null) {
      this.flkty.playPlayer();
    }
  }

  onReorder() {
    if (this.flkty !== null) {
      this.flkty.resize();
    }
  }

  onUnload() {
    if (this.flkty !== null) {
      document.removeEventListener('theme:vars', this.resizeEvent);
      this.flkty.destroy();
      this.flkty = null;
    }
  }
}

const slider = {
  onLoad() {
    sections$1[this.id] = new Slider(this);
  },
  onReorder(e) {
    sections$1[this.id].onReorder(e);
  },
  onUnload(e) {
    sections$1[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections$1[this.id].onBlockSelect(e);
  },
  onBlockDeselect(e) {
    sections$1[this.id].onBlockDeselect(e);
  },
};

register('slider', [slider, videoPlay, zoomAnimation]);





